function Colombia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_947)">
  <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16L16 17.3913L0 16Z" fill="#FFDA44"/>
  <path d="M2.14099 24.0005C4.90755 28.7828 10.0778 32.0005 16 32.0005C21.9222 32.0005 27.0924 28.7828 29.859 24.0005L16 22.957L2.14099 24.0005Z" fill="#D80027"/>
  <path d="M29.859 24C31.2204 21.6466 32 18.9144 32 16H0C0 18.9144 0.779625 21.6466 2.141 24H29.859Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Colombia;
